import { signal } from "@preact/signals-react";

export const languageSignal = signal('en'); // Default language
